import React, { useCallback, useState } from 'react';
import { useClipboard } from 'use-clipboard-copy';
import { IconButton } from '@saucelabs/ds-button';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';
import { IconCheckmarkFill, IconCopyFill } from '@saucelabs/ds-icons';
import { Tooltip } from '@saucelabs/ds-tooltip';
import { Typography } from '@saucelabs/ds-typography';

import constants from '../../../constants';

type TableCellIdentifierProps = {
  file: appStorageRecords.AppStorageFile,
};

const TableCellIdentifier: React.FC<TableCellIdentifierProps> = ({ file }) => {
  const [buttonHoverState, setButtonHoverState] = useState(false);

  const clipboardFileIdentifier = useClipboard({
    copiedTimeout: constants.CLIPBOARD_COPIED_TIMEOUT_MS,
  });
  const copyFileIdentifierToClipboard = useCallback(() => {
    clipboardFileIdentifier.copy(file.id);
  }, [clipboardFileIdentifier, file.id]);

  return (
    <div className="flex flex-row max-w-48 break-all">
      <Typography
        data-qa="app-management-files-table-cell-identifier-label"
      >
        {file.id}
      </Typography>
      <>
        <Tooltip // for copied state
          isOpen={clipboardFileIdentifier.copied === true}
          placement="top"
          title={constants.CLIPBOARD_COPIED_TOOLTIP_TEXT}
        >
          <Tooltip // "normal" tooltip
            isOpen={buttonHoverState && !clipboardFileIdentifier.copied === true}
            placement="top"
            title={constants.CLIPBOARD_HOVER_TOOLTIP_TEXT}
          >
            <div
              // This custom hover state handling is required to make
              // both <Tooltips> working without `isOpen` state issues
              onMouseEnter={() => setButtonHoverState(true)}
              onMouseLeave={() => setButtonHoverState(false)}
            >
              <IconButton
                className="ml-1 opacity-0 group-hover:opacity-100"
                color="primary"
                icon={clipboardFileIdentifier.copied ? <IconCheckmarkFill /> : <IconCopyFill />}
                onPress={copyFileIdentifierToClipboard}
                size="sm"
                variant="text"
              />
            </div>
          </Tooltip>
        </Tooltip>
      </>
    </div>
  );
};

export default TableCellIdentifier;
